import * as actionTypes from '../actions/types';

const initialState = {
    mostrarSnack: false,
    mensajeSnack: '',
};

export function snackMensajeReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.ACTUALIZAR_ATRIBUTOS_SNACK:
            return {
                ...initialState,
                ...action.payload,
            };

        default:
            return state;
    }
}
